$(function () {
  $('#special-navs').on('click', '.nav', function () {
    var id = $(this).attr('data-id');
    if ($('#special-navs .nav.active').attr('data-id') === id) {
      return;
    }
    $('#special-navs .nav.active').removeClass('active');
    $(this).addClass('active');
    $('.special-wrap').hide();
    $('.special-wrap').each(function () {
      if ($(this).attr('data-id') === id) {
        $(this).show();
      }
    });
  });
});



//////////////////
// WEBPACK FOOTER
// ./cms/client/js/special.page.js
// module id = 43
// module chunks = 5